import React, {Component, Fragment} from 'react';
import '../../App.css';

import Modal from 'react-responsive-modal';
import request from 'request-promise-native';

import FormControl from 'react-bootstrap/lib/FormControl';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import Form from 'react-bootstrap/lib/Form';
import Col from 'react-bootstrap/lib/Col';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import Button from 'react-bootstrap/lib/Button';
import HelpBlock from "react-bootstrap/lib/HelpBlock";
import ProgressBar from "react-bootstrap/lib/ProgressBar";
import Alert from "react-bootstrap/lib/Alert";
import ValidatedFormComponent from "../ValidatedFormComponent";
import AzureTable from "../AzureTable";
import "react-table/react-table.css";
import CardSub from "../subcomponents/CardSub";
import Row from "react-bootstrap/es/Row";
import DeviceConfig from "./DeviceConfig";

const ADD_DEVICE_ENDPOINT = "https://qibipay.azurewebsites.net/api/VMAdd";
const CONFIGURE_DEVICE_ENDPOINT = "https://qibipay.azurewebsites.net/api/VMConfig";

const GET_CARDS_URL = "https://qibipay.azurewebsites.net/api/GetRecipeList";

const mdbCurrencyCodes = {
    CHF: "0x1756",
    USD: "0x1840",
    EUR: "0x1978"
};

class AddDeviceModal extends Component {
    constructor(props) {
        /*
            Props:
             - access_code
             - open
             - onClose
             - tableRef
             - logout

             - device
        */
        super(props);
        this.state = {
            hide: false,
            loading: false
        }
    }

    async submit() {
        console.log("Submited ref: "+this.submitRef);
        await this.submitRef();
    }

    render() {
        return(
            <Fragment>

                <Modal open={this.props.open} onClose={() => {
                    this.props.onClose();
                }} styles={{
                    modal: {
                        minWidth: '600px'
                    }
                }} >
                    <h2>{this.props.device===null ? 'Add Device' : 'Configure Device'}</h2>

                    <DeviceConfig
                        access_code={this.props.access_code}
                        open={true}
                        tableRef={this.props.tableRef}
                        logout={this.props.logout}
                        device={this.props.device}
                        admin={this.props.admin}
                        submitFunc={(subRef) => {
                            this.submitRef = subRef;
                        }}
                        onLoading={(loading) => {
                            this.setState({
                                loading
                            });
                        }}
                        onHideBtn={(hide)=> {
                            this.setState({
                                hide
                            });
                        }}
                    />

                    {this.state.hide ? "" : (
                        <>
                            <Col sm={4}/>
                            <Col sm={8}>
                                <Button bsStyle="primary" disabled={this.state.loading} onClick={this.submit.bind(this)}>
                                    {this.props.device===null ? 'Add Device' : 'Configure Device'}
                                </Button>
                            </Col>
                        </>
                    )}
                </Modal>
            </Fragment>
        );
    }

}

export default AddDeviceModal;